import { Box, Text } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';
import { checks } from './utils';

interface Props {
	value: string;
}

export const Checks = (props: Props) => {
	const { value } = props;

	return (
		<>
			{checks.map((check) => {
				const meets = check.re.test(value);
				return (
					<Box
						key={check.label}
						c={meets ? 'teal' : 'red'}
						style={{ display: 'flex', alignItems: 'center' }}
						mt={7}
						size="sm"
					>
						{meets ? <IconCheck size={14} /> : <IconX size={14} />}
						<Text ml={10} size="sm">
							{check.label}
						</Text>
					</Box>
				);
			})}
		</>
	);
};
